import EventBus from 'js-event-bus';

const eventBus = new EventBus();

(window as unknown as {eventBus: EventBus}).eventBus = eventBus;

export { eventBus };
